import { useContext } from 'react';

import { ResourcesContext } from '../context';

const useResources = () => {
  const context = useContext(ResourcesContext);

  if (!context) {
    throw new Error('useResources must be used within a ResourcesProvider');
  }

  return context;
};

export default useResources;
